import { atom } from '../../factories/atom.js';
import { AtomInstance } from '../instances/AtomInstance.js';
import { AtomTemplateBase } from './AtomTemplateBase.js';
export class AtomTemplate extends AtomTemplateBase {
    /**
     * This method should be overridden when creating custom atom classes that
     * create a custom atom instance class. Return a new instance of your atom
     * instance class.
     */
    _createInstance(ecosystem, id, params) {
        return new AtomInstance(ecosystem, this, id, params);
    }
    getInstanceId(ecosystem, params) {
        const base = this.key;
        if (!(params === null || params === void 0 ? void 0 : params.length))
            return base;
        return `${base}-${ecosystem._idGenerator.hashParams(params, ecosystem.complexParams)}`;
    }
    override(newValue) {
        const newAtom = atom(this.key, newValue, this._config);
        newAtom._isOverride = true;
        return newAtom;
    }
}
